import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";
const { bargainEditStatus } = httpApi.margin;

export interface PageSize {
  page: number;
  size: number;
}

// 修改状态
interface BargainEditStatusParams {
  id: string;
  status: number;
}
export const apiBargainEditStatus = (json: BargainEditStatusParams): any =>
  http.httpPost({
    url: bargainEditStatus,
    json,
  });
